import React, { useState } from 'react';
import styles from './style.css';
import Button from '../Button/Button';
import iconPdf from '../../images/icon_pdf.svg';
import iconCollapse from '../../images/collapse-icon-blue.svg';
import { getRDFProspLinks } from './utils';

const RDFProspLinksSection = ({
  amount = 0,
  iClassRewards = false,
  allRetirementDateFundsData
}) => {
  const [expanded, setExpanded] = useState(true);

  const toggleExpanded = () => setExpanded(!expanded);

  const rdfProspectusLinks = getRDFProspLinks(
    amount,
    iClassRewards,
    allRetirementDateFundsData
  );
  const numberInFirstCol = Math.ceil(rdfProspectusLinks.length / 2);

  const firstColRDFProspLink = rdfProspectusLinks.slice(0, numberInFirstCol);
  const secondColRDFProspLink = rdfProspectusLinks.slice(numberInFirstCol);

  return (
    <>
      <p>
        <Button btnStyle="link-button btn-expand" onClick={toggleExpanded}>
          {expanded ? 'Collapse' : 'Expand'}{' '}
          <img
            alt="Arrow"
            className={`toggle-arrow${expanded ? '' : ' collapsed'}`}
            src={iconCollapse}
          />
        </Button>
      </p>
      <div
        className={`rdf-row pros-links-section${expanded ? '' : ' collapsed'}`}>
        <div className="rdf-col">
          {firstColRDFProspLink.map(({ linkText, linkURL }) => {
            return (
              <a className="pros-link" key={linkText} href={linkURL}>
                <span>{linkText}</span>
                <img alt="PDF Icon" src={iconPdf} />
              </a>
            );
          })}
        </div>
        <div className="rdf-col">
          {secondColRDFProspLink.map(({ linkText, linkURL }) => {
            return (
              <a className="pros-link" key={linkText} href={linkURL}>
                <span>{linkText}</span>
                <img alt="PDF Icon" src={iconPdf} />
              </a>
            );
          })}
        </div>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default RDFProspLinksSection;
